class LookbookSidebar {
  public sidebar: HTMLElement | null;
  public sidebarCloseButton: HTMLAnchorElement | null;
  public sidebarBadge: HTMLElement | null;
  public sidebarOpenButton: HTMLAnchorElement | null;
  public sidebarObserver: HTMLElement | null;

  cache() {
    this.sidebar = document.querySelector('.js-o-lookbook-sidebar__sidebar');
    this.sidebarCloseButton = document.querySelector('.js-o-lookbook-sidebar__sidebar-close');
    this.sidebarOpenButton = document.querySelector('.js-o-lookbook-sidebar__sidebar-open');
    this.sidebarBadge = document.querySelector('.js-o-lookbook-sidebar__sidebar-badge');
    this.sidebarObserver = document.querySelector('.js-o-lookbook-sidebar__observable');
  }

  bindings() {
    
    if (this.sidebarCloseButton) {
      this.sidebarCloseButton.addEventListener('click', (e: Event) => {
        e.preventDefault();

        if (this.sidebar) {
          this.sidebar.classList.remove('is-visible');
          this.sidebar.classList.add('is-hidden');
        }
        if(this.sidebarBadge) {
          this.sidebarBadge.classList.remove('is-hidden');
        }
      });
    }
    if (this.sidebarOpenButton) {
      this.sidebarOpenButton.addEventListener('click', (e: Event) => {
        e.preventDefault();
        
        if (this.sidebar) {
          this.sidebar.classList.add('is-visible');
          this.sidebar.classList.remove('is-hidden');
        }
        if(this.sidebarBadge) {
          this.sidebarBadge.classList.add('is-hidden');
        }
      });
    }
    if(this.sidebarObserver) {
      this.sidebarObserver.addEventListener('visibility-changed', () => {
        if(this.sidebar) {
          this.sidebar.classList.add('is-visible');
          this.sidebar.classList.remove('is-hidden');
        }
      })
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default LookbookSidebar;
